var exports = {
  "Qs": "xcc377c0b--d90f5a--content",
  "CS": "xcc377c0b--d90f5a--animated",
  "ne": "xcc377c0b--d90f5a--controls",
  "Cy": "xcc377c0b--d90f5a--controls--with-button",
};

module.exports = exports;
